/**
 * Props that keep password managers from treating the header search as a login
 * or address field.
 */
export const blockBrowserAutofillProps = {
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  "data-1p-ignore": "true",
  "data-lpignore": "true",
  "data-form-type": "other",
};

/**
 * Props for city and location fields.
 * `autoComplete` is "new-password" on purpose: Chrome ignores "off" on fields
 * whose label or placeholder looks like a city or address, and still shows
 * saved-address suggestions. It does not show those on a new-password field.
 */
export const blockLocationAutofillProps = {
  autoComplete: "new-password",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  "aria-autocomplete": "none",
  "data-1p-ignore": "true",
  "data-lpignore": "true",
  "data-bwignore": "true",
  "data-form-type": "other",
};

/**
 * True when the person typed, pasted, or deleted in the focused field.
 * Browser autofill is not a user edit: it often targets a field that is not
 * focused, and Chrome labels that insert as insertReplacementText.
 *
 * @param {React.SyntheticEvent<HTMLInputElement>} event
 * @returns {boolean}
 */
export function isUserInputEvent(event) {
  const target = event.currentTarget;
  if (!(target instanceof HTMLInputElement)) return false;
  if (document.activeElement !== target) return false;
  const inputType = event.nativeEvent && event.nativeEvent.inputType;
  if (typeof inputType !== "string" || inputType.length === 0) return false;
  if (inputType === "insertReplacementText") return false;
  return true;
}

/**
 * Put the DOM value back when a browser wrote into a controlled input.
 *
 * @param {React.SyntheticEvent<HTMLInputElement>} event
 * @param {string} value
 * @returns {void}
 */
export function revertUntrustedInput(event, value) {
  if (event.currentTarget.value !== value) {
    event.currentTarget.value = value;
  }
}
